"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SearchBox = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _translations = require("../../libs/translationsUtils/translations");

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _globals = require("@insided/shared/utils/globals");

var _FormPrefiller = require("@insided/destination/modules/Content/TopicCreation/FormPrefiller");

var _connectors = require("@insided/shared/services/algolia/connectors");

var _classnames = _interopRequireDefault(require("classnames"));

var _common = require("@insided/shared/utils/common");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TOPIC_TITLE_ID = 'topic_title';

var SearchBox = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SearchBox, _Component);

  var _super = _createSuper(SearchBox);

  function SearchBox() {
    var _this;

    (0, _classCallCheck2.default)(this, SearchBox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "timeout", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      enableLoader: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "prefillInput", function () {
      // Apply the initial value from URL query parameters on component mount
      var initialValue = (0, _FormPrefiller.getTitleFromParams)();

      if (initialValue) {
        // Find the input element
        var input = document.getElementById(TOPIC_TITLE_ID);

        if (input) {
          // Set the value
          input.value = initialValue; // Trigger search

          _this.doSearch(initialValue);
        }
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onEnter", function (e) {
      e.stopPropagation();
      e.preventDefault();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "doSearch", function (value) {
      clearTimeout(_this.timeout);

      _this.props.refine(value);

      _this.setState({
        enableLoader: false
      });

      (0, _globals.publish)('title_changed', {
        title: value
      });

      if (value === '') {
        _this.props.hideSuggestionsCallback(true);

        return;
      }

      _this.setState({
        enableLoader: true
      });

      _this.timeout = window.setTimeout(function () {
        _this.props.hideSuggestionsCallback(false);

        _this.setState({
          enableLoader: false
        });
      }, 500);
    });
    return _this;
  }

  (0, _createClass2.default)(SearchBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (_common.common.isModuleActive('prefillTopicCreationFormFromURL')) {
        // Prefill the input with the value from URL query parameters
        this.prefillInput();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props,
          state = this.state;
      return (0, _preact.h)("div", {
        className: "form__row"
      }, (0, _preact.h)("div", {
        className: "first"
      }, (0, _preact.h)("label", {
        htmlFor: TOPIC_TITLE_ID
      }, (0, _preact.h)(_phrase.default, {
        p: "Title"
      }))), (0, _preact.h)("div", {
        className: "second loading-wrapper"
      }, (0, _preact.h)("input", {
        type: "search",
        id: TOPIC_TITLE_ID,
        placeholder: (0, _translations.t)('Forum', 'Enter a clear title here'),
        required: "required",
        name: "topic[title]",
        autoComplete: "off",
        autoCorrect: "off",
        autoCapitalize: "off",
        onKeyUp: function onKeyUp(event) {
          _this2.doSearch(event.currentTarget.value);
        },
        onKeyDown: function onKeyDown(event) {
          return event.key === 'Enter' ? _this2.onEnter(event) : null;
        }
      }), state.enableLoader && (0, _preact.h)(Loader, {
        defaultCdn: props.defaultCdn
      })));
    }
  }]);
  return SearchBox;
}(_preact.Component);

exports.SearchBox = SearchBox;

var Loader = function Loader(_ref) {
  var defaultCdn = _ref.defaultCdn;
  return (0, _preact.h)("span", {
    className: (0, _classnames.default)('topic-suggestion-loader', 'small-loader', 'is-hidden')
  }, (0, _preact.h)("img", {
    src: (0, _absoluteUrlRuntime.resolveUrl)("".concat(defaultCdn, "/images/spinner.gif")),
    alt: "loading..."
  }));
};

var CustomSearchBox = (0, _connectors.connectSearchBox)(SearchBox);
var _default = CustomSearchBox;
exports.default = _default;